var map = {
	"./EditClient.vue": "./src/modules/clients/views/EditClient.vue",
	"./EditDocumentTemplate.vue": "./src/modules/clients/views/EditDocumentTemplate.vue",
	"./EditIndustry.vue": "./src/modules/clients/views/EditIndustry.vue",
	"./EditJobListing.vue": "./src/modules/clients/views/EditJobListing.vue",
	"./ListClient.vue": "./src/modules/clients/views/ListClient.vue",
	"./ListDocumentTemplate.vue": "./src/modules/clients/views/ListDocumentTemplate.vue",
	"./ListIndustry.vue": "./src/modules/clients/views/ListIndustry.vue",
	"./ListJobListing.vue": "./src/modules/clients/views/ListJobListing.vue",
	"./ViewJobListing.vue": "./src/modules/clients/views/ViewJobListing.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/modules/clients/views sync recursive \\.vue$";